// @ts-nocheck
import angular from "angular";

angular.module("ticketco/ticketbuyer/common").component("addressQuestion",{
    require: {ngModelCtrl: "ngModel"},
    bindings: {
      form: "<",
      value: "=ngModel",
      onChange: "&",
      required: "<ngRequired",
      countries: "<",
      id: "@",
    },
    templateUrl: "addressQuestionDirective.html",
    controller: function ($scope ) {
      const self = this;
      this.$onInit = () => {
        this.value = this.value ?? {country: this.countries[0], address_line1: null, address_line2: null, city: null, zip: null };
        this.ngModelCtrl.allowInvalid = true;
        this.ngModelCtrl.$isEmpty = function (value) {
          if (!value || typeof value != "object") {
            return true;
          }

          return ["address_line1", "city", "zip"]
            .some((fieldName) => value[fieldName]?.trim() == null || value[fieldName]?.trim() === "");
        }
      };


      this.onChangeField = function (fieldName, value) {
        self.value = Object.assign({}, self.value, {[fieldName]: value});
        self.ngModelCtrl.$setViewValue(self.value, "change");
        self.ngModelCtrl.$render();
      };
    },
  });
